export default "__VITE_ASSET__Oi5MMAoG__"